import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  EventTypesListComponent,
  EventTypeFormComponent,
  EventTypePreviewComponent,
  EventTypeSectionComponent,
  EventTypeSectionFieldComponent,
  EventTypeSectionPredefinedFieldsComponent
} from '../upgrade/event-types.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

export const eventTypesRoutes: Routes = [
  {
    path: 'event-types',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    data: {
      permission: 'eventTypes.view'
    },
    children: [
      {
        path: '',
        component: EventTypesListComponent,
        data: {
          state: 'epf.event-types.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'new',
        component: EventTypeFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'eventTypes.edit',
          state: 'epf.event-types.new',
          action: 'new'
        }
      },
      {
        path: ':id/edit',
        component: EventTypeFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'eventTypes.edit',
          state: 'epf.event-types.edit',
          action: 'edit'
        }
      },
      {
        path: 'preview/:id',
        component: EventTypePreviewComponent,
        canActivate: [authGuard, forceOnlineGuard],
        data: {
          permission: 'eventTypes.view',
          state: 'epf.event-types.preview'
        }
      },
      {
        path: ':id/section/:sectionId',
        component: EventTypeSectionComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'eventTypes.edit',
          state: 'epf.event-types.section'
        }
      },
      {
        path: ':id/section/:sectionId/field/:fieldId',
        component: EventTypeSectionFieldComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'eventTypes.edit',
          state: 'epf.event-types.field'
        }
      },
      {
        path: ':id/section/:sectionId/custom-fields',
        component: EventTypeSectionPredefinedFieldsComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'eventTypes.edit',
          state: 'epf.event-types.custom-fields'
        }
      }
    ]
  }
];
